import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ExecutionStep, WebhookLogComponent } from "../webhook-log.component";
import {} from '../webhook-log.component'
 


@Component({
    selector: 'webhook-log-detail-child',
    templateUrl: '../webhook-log.component.html',
    styleUrl: '../webhook-log.component.scss',
    standalone: false
})

export class WebhookLogChildComponent extends WebhookLogComponent {
  @Input() children: ExecutionStep[] = [];

}